import Item from 'owa-service/lib/contract/Item';

export default function isMeetingMessage(item: Item) {
    return item.ItemClass.match(/^ipm\.(appointment|schedule\.meeting(?!\.notification))/i);
}
